import {LocalStorageProvider, UnleashClient} from 'unleash-proxy-client';
import {config} from '../config';
import {productionFallbackFlags} from './unleashFallbackFlags';
import type {CountryCodeType} from '@resurs-internal/rb-app-api/model/Country';

export const unleash = new UnleashClient({
  appName: config.clientName,
  url: config.links.unleash,
  clientKey: config.apiKey,
  disableMetrics: true,
  storageProvider: new LocalStorageProvider(),
  customHeaders: {
    apiKey: config.apiKey,
  },
  context: {
    properties: {
      version: config.clientVersion,
    },
  },
});

let startPromise: Promise<void> | null = null;
export const startUnleash = (): Promise<void> => {
  if (unleash.isReady()) return Promise.resolve();
  if (!startPromise) {
    startPromise = unleash.start();
  }
  return startPromise;
};

export type FeatureToggle = string;

export const isEnabled = (
  toggle: FeatureToggle,
  country?: CountryCodeType,
): boolean => {
  if (!unleash.isReady()) {
    if (!country) return true;
    return productionFallbackFlags[country]?.[toggle] ?? true;
  }
  return unleash.isEnabled(toggle);
};

export const getVariant = (toggle: FeatureToggle) => {
  return unleash.getVariant(toggle);
};
